const CENTS_PER_EURO = 100;
const FLOAT_ERROR_NUDGE = 1e-9;

// Rounds to cents, half away from zero, matching the backend's MidpointRounding.AwayFromZero. The tiny
// nudge corrects binary-float representation error (e.g. 2.505 stored as 2.50499…) so exact half-cents
// round like exact decimals would.
export function roundToCents(value: number): number {
  const rounded = Math.round(Math.abs(value) * CENTS_PER_EURO + FLOAT_ERROR_NUDGE) / CENTS_PER_EURO;
  return value < 0 && rounded !== 0 ? -rounded : rounded;
}
